var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',{attrs:{"options":_vm.dispensers},on:{"change":_vm.selectChange},model:{value:(_vm.localSelected),callback:function ($$v) {_vm.localSelected=$$v},expression:"localSelected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }